import { render, staticRenderFns } from "./MmfIcon.vue?vue&type=template&id=2fa3fe54&"
import script from "./MmfIcon.vue?vue&type=script&lang=js&"
export * from "./MmfIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports